import {
  ComponentPropsWithoutRef,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'
import { mtc, TextColors, TypographyStyles } from '@/styles'
import { Tooltip } from '../tooltip'
import { styles } from '../text/styles'
import { Button } from '../button'

export interface CopyTextProps extends ComponentPropsWithoutRef<'button'> {
  value: string
  children?: ReactNode
  className?: string
  color?: TextColors
  variant?: TypographyStyles
}

export const CopyText = ({
  value,
  children,
  className,
  color,
  variant,
  ...props
}: CopyTextProps) => {
  const [copied, setCopied] = useState(false)
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  const handleClick = () => {
    navigator.clipboard.writeText(value)
    setCopied(true)
    timeoutRef.current = setTimeout(() => setCopied(false), 1500)
  }

  return (
    <Tooltip.Provider>
      <Tooltip open={copied || undefined}>
        <Tooltip.Trigger asChild>
          <Button
            type="button"
            variant="ghost"
            className={mtc(
              styles({ color, variant }),
              'h-auto p-0 text-left font-normal rounded-none',
              className
            )}
            onClick={handleClick}
            {...props}
          >
            {children ?? value}
          </Button>
        </Tooltip.Trigger>
        <Tooltip.Content>
          {copied ? 'Copied!' : 'Click to copy'}
        </Tooltip.Content>
      </Tooltip>
    </Tooltip.Provider>
  )
}
